import React from 'react';
import HelpDialog from '../HelpDialog';

class Dialogs extends React.Component {
  render() {
    const { currentOpenDialog } = this.props;

    switch (currentOpenDialog) {
      case 'help':
        return <HelpDialog />;

      default:
        return <React.Fragment />
    }
  }
}

export default Dialogs;



// WEBPACK FOOTER //
// ./src/components/dialogs/Dialogs/Dialogs.js